// extracted by mini-css-extract-plugin
module.exports = {"drawer__body__items":"AllUnavailableItemsModal_drawer__body__items__A_7ZP"};